export enum AbastecimentoAguaTipo {
  POCO = 'POCO',
  COLETIVO = 'COLETIVO',
  OUTRO = 'OUTRO',
}
